import React from "react";
import logo from "../images/Score-Buzzer-logo.png";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { textAlign } from "@mui/system";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Hidden,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
  handleSelectInput: (event: any) => void;
  handleFilter?: (event: any) => void;
  handleButtonClick: (event: any) => void;
  handleEventInput: (event: any) => void;
  handleScheduled: (event: any) => void;
  handleCompleted: (event: any) => void;
  handleLive: (event: any) => void;
  handleAll: (event: any) => void;
  selectedEvent: any;
  selectedStatus: any;
  touranamentName: any;
  dateRange: any;
  // key :any;
  Live: any;
  Scheduled: any;
  Completed: any;
  All: any;
  autoCompleteData: any;
  title: string;
}

export  function Header(props: Props) {
  return (
    <div className="flex flex-col md:flex-row mx-0  my-2   md:justify-between pl-2 " >
      <Hidden mdDown>
        <div>
          <a href="https://home.scorebuzzer.com" target="_blank" rel="noopener noreferrer">
            <img
              className="w-16 md:w-16 lg:w-16 xl:w-12 2xl:w-12"
              src={logo}
              alt="Logo"
            />
          </a>
        </div>

        <div
          className=" flex flex-col md:mt-0  items-center md:items-start       md:w-3/6 ml-0"
          style={{
            marginTop: "0px",
            marginRight: "10px",
            marginLeft: "1%",
          }}
        >
          <div>
            <h1
              className="text-center sm:text-start ml-2"
              style={{ fontSize: 14, color: "#4A5DB5", fontWeight: "bold" }}
            >
              {" "}
              {props.touranamentName}
            </h1>
          </div>
          <div>
            <h1
              className="ml-2"
              style={{ fontSize: 14, color: "#5c5c5e", alignItems: "center" }}
            >
              {props.dateRange}
            </h1>
          </div>
        </div>
      </Hidden>

      <Hidden mdUp>
        <Accordion
          elevation={0}
          sx={{
            border: "hidden",
            borderRadius: "11px 11px 11px 11px",
            borderColor: "inherit",
            backgroundColor: "inherit",
            marginBottom: "-10px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              border: "hidden",
              backgroundColor: "inherit",
              borderRadius: "11px 11px 0px 0px",
              borderColor: "inherit",
            }}
          >
            <div
              style={{
                marginLeft: "-5px",
                marginTop: "-4px",
                marginBottom: "-4px",
              }}
            >
              {" "}
              <a href="https://home.scorebuzzer.com" target="_blank" rel="noopener noreferrer">
                <img className="w-14 h-12" src={logo} alt="Logo" />
              </a>
            </div>
            <div
              className=" flex flex-col mt-0 md:mt-0  mr-2   items-center md:items-start   p-0     w-full ml-0 pl-0 "
              style={{ marginTop: "-4px", marginLeft: "0px" }}
            >
              <div>
                <h1
                  className="text-center sm:text-start ml-0"
                  style={{
                    fontSize: 12,
                    color: "#4a5db5",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  {props.touranamentName}
                </h1>
              </div>
              <div>
                <h1
                  className="ml-0"
                  style={{
                    fontSize: 12,
                    color: "#4a5db5",
                    alignItems: "center",
                  }}
                >
                  {props.dateRange}
                </h1>
              </div>
            </div>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              border: "none",
              backgroundColor: "inherit",
            }}
          >
            <div
              className="flex flex-col justify-center mx-auto"
              style={{ marginTop: "-4px" }}
            >
              <div
                className="flex flex-col mx-auto w-100 my-0 "
                // style={{ marginLeft: "40px" }}
              >
                <div className="flex flex-row ">
                  <div>
                    <Button
                      className={`w-30 h-5 ${
                        props.selectedStatus === props.Live ? "active" : ""
                      }`}
                      variant="outlined"
                      style={{
                        backgroundColor:
                          props.selectedStatus === props.Live
                            ? "#c2cdff"
                            : "white",
                      }}
                      //onClick={props.handleLive}
                      onClick={() => {
                        props.handleButtonClick(props.Live);
                        props.handleLive(null);
                      }}
                    >
                      <p className="" style={{ fontSize: 12 }}>
                        Live
                      </p>
                    </Button>
                  </div>
                  <div className="ml-1">
                    <Button
                      className={`w-30 h-5 ${
                        props.selectedStatus === props.Scheduled ? "active" : ""
                      }`}
                      variant="outlined"
                      style={{
                        backgroundColor:
                          props.selectedStatus === props.Scheduled
                            ? "#c2cdff"
                            : "white",
                      }}
                      //onClick={props.handleScheduled}
                      onClick={() => {
                        props.handleButtonClick(props.Scheduled);
                        props.handleScheduled(null);
                      }}
                    >
                      <p className="" style={{ fontSize: 12 }}>
                        Scheduled
                      </p>
                    </Button>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div>
                    <Button
                      className={`w-30 h-5 ${
                        props.selectedStatus === props.Completed ? "active" : ""
                      }`}
                      variant="outlined"
                      style={{
                        backgroundColor:
                          props.selectedStatus === props.Completed
                            ? "#c2cdff"
                            : "white",
                      }}
                      onClick={() => {
                        props.handleButtonClick(props.Completed);
                        props.handleCompleted(null);
                      }}
                    >
                      <p style={{ fontSize: 12 }}> Completed </p>
                    </Button>
                  </div>
                  <div className="ml-1">
                    <Button
                      className="w-30 h-5"
                      variant="outlined"
                      style={{
                        backgroundColor:
                          props.selectedStatus === props.All
                            ? "#4a5db5"
                            : "white",
                        color:
                          props.selectedStatus === props.All
                            ? "white"
                            : "#4a5db5",
                      }}
                      onClick={() => {
                        props.handleButtonClick(props.All);
                        props.handleAll(null);
                      }}
                    >
                      <p style={{ fontSize: 12 }}> All </p>
                    </Button>
                  </div>
                </div>
              </div>

              <div className="flex flex-col mt-1 mb-0 justify-evenly mx-auto">
                <div className="my-1">
                  <Autocomplete
                    clearOnBlur={true}
                    size="small"
                    // key ={props.key}
                    options={props.autoCompleteData}
                    onChange={props.handleSelectInput}
                    sx={{
                      width: 200,
                      backgroundColor: "white",
                     
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // onChange={props.handleSelectInput}
                        // value={props.selectedCourt}
                        // label={props.title}
                        placeholder={props.title}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </Hidden>

      <Hidden mdDown>
        <div className="flex flex-row mt-0 mb-0 justify-evenly ">
          <div>
            <Autocomplete
              clearOnBlur={true}
              size="small"
              // key ={props.key}

              options={props.autoCompleteData}
              onChange={props.handleSelectInput}
              sx={{
                width: 300,
                backgroundColor: "white",
                marginRight: 10,
                marginLeft: 10,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // onChange={props.handleSelectInput}
                  // value={props.selectedCourt}
                  // label={props.title}
                  placeholder={props.title}
                />
              )}
            />
            {/* <TextField
              className="court-field"
              size="small"
              label={props.title}
              onChange={props.handleSelectInput}
              value={props.selectedCourt}
              style={{ backgroundColor: "white" }}
            /> */}
          </div>
          {/* <div className="mx-1 md:mx-2 ">
            <Button
              style={{
                textTransform: "none",
                backgroundColor: "#4a5db5",
                marginTop: "1px",
              }}
              variant="contained"
              onClick={props.handleFilter}
            >
              {" "}
              Filter{" "}
            </Button>
          </div> */}
        </div>
      </Hidden>

      <Hidden mdDown>
        <div
          className="flex flex-col mx-2 w-100 my-0 "
          style={{
            marginTop: "-2px",
            marginLeft: "-50px",
            marginRight: "80px",
          }}
        >
          <div className="flex flex-row ">
            <div>
              <Button
                className={`w-30 h-5 ${
                  props.selectedStatus === props.Live ? "active" : ""
                }`}
                variant="outlined"
                style={{
                  backgroundColor:
                    props.selectedStatus === props.Live ? "#c2cdff" : "white",
                }}
                onClick={() => {
                  props.handleButtonClick(props.Live);
                  props.handleLive(null);
                }}
              >
                <p style={{ fontSize: 12 }}> Live </p>
              </Button>
            </div>
            <div className="ml-1">
              <Button
                className={`w-30 h-5 ${
                  props.selectedStatus === props.Scheduled ? "active" : ""
                }`}
                variant="outlined"
                style={{
                  backgroundColor:
                    props.selectedStatus === props.Scheduled
                      ? "#c2cdff"
                      : "white",
                }}
                onClick={() => {
                  props.handleButtonClick(props.Scheduled);
                  props.handleScheduled(null);
                }}
              >
                <p className="" style={{ fontSize: 12 }}>
                  {" "}
                  Scheduled{" "}
                </p>
              </Button>
            </div>
          </div>
          <div className="flex flex-row">
            <div>
              <Button
                className={`w-30 h-5 ${
                  props.selectedStatus === props.Completed ? "active" : ""
                }`}
                variant="outlined"
                style={{
                  backgroundColor:
                    props.selectedStatus === props.Completed
                      ? "#c2cdff"
                      : "white",
                }}
                onClick={() => {
                  props.handleButtonClick(props.Completed);
                  props.handleCompleted(null);
                }}
              >
                <p style={{ fontSize: 12 }}> Completed </p>
              </Button>
            </div>
            <div className="ml-1">
              <Button
                className={`w-30 h-5 ${
                  props.selectedStatus === props.All ? "active" : ""
                }`}
                variant="outlined"
                style={{
                  backgroundColor:
                    props.selectedStatus === props.All ? "#4a5db5" : "white",
                  color:
                    props.selectedStatus === props.All ? "white" : "#4a5db5",
                }}
                onClick={() => {
                  props.handleButtonClick(props.All);
                  props.handleAll(null);
                }}
              >
                <p style={{ fontSize: 12 }}> All </p>
              </Button>
            </div>
          </div>
        </div>
      </Hidden>
    </div>
  );
}

export  function MatchHeader() {
  return (
    <div className="flex flex-col md:flex-row mx-0  my-2   md:justify-between pl-2 " >
      <Hidden mdDown>
        <div>
          <a href="https://home.scorebuzzer.com" target="_blank" rel="noopener noreferrer">
            <img
              className="w-16 md:w-16 lg:w-16 xl:w-12 2xl:w-12"
              src={logo}
              alt="Logo"
            />
          </a>
        </div>

        
      </Hidden>

      <Hidden mdUp>
        <Accordion
          elevation={0}
          sx={{
            border: "hidden",
            borderRadius: "11px 11px 11px 11px",
            borderColor: "inherit",
            backgroundColor: "inherit",
            marginBottom: "-10px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              border: "hidden",
              backgroundColor: "inherit",
              borderRadius: "11px 11px 0px 0px",
              borderColor: "inherit",
            }}
          >
            <div
              style={{
                marginLeft: "-5px",
                marginTop: "-4px",
                marginBottom: "-4px",
              }}
            >
              {" "}
              <a href="https://home.scorebuzzer.com" target="_blank" rel="noopener noreferrer">
                <img className="w-14 h-12" src={logo} alt="Logo" />
              </a>
            </div>

          </AccordionSummary>

        </Accordion>
      </Hidden>

     
    </div>
  );
}